import { MAIL_FAILURE_REASONS, MAIL_TYPES } from 'cpool-constants';
import { z } from 'zod';

export const schemaEmailMessageCreatedPayload = z.object({
    attachments: z
        .array(
            z.object({
                bucket: z.string().min(1).optional(),
                fileExtension: z.string().min(1),
                key: z.string().min(1),
                mimeType: z.string().min(1),
                name: z.string().min(1),
            }),
        )
        .nullable(),
    bcc: z.array(z.string().email()).optional(),
    body: z.object({
        html: z.string().optional(),
        text: z.string().min(1),
    }),
    cc: z.array(z.string().email()).optional(),
    from: z.string().email(),
    fromName: z.string().optional(),
    fromUserId: z.string().min(1).optional(),
    offerIds: z.array(z.string()).optional(),
    smime: z.object({ cert: z.string(), key: z.string() }).optional(),
    subject: z.string().min(1),
    substitutions: z.record(z.string(), z.string().or(z.object({ html: z.string(), txt: z.string() }))).optional(),
    to: z.string().email(),
    toName: z.string().optional(),
    type: z.nativeEnum(MAIL_TYPES).optional(),
});

export const schemaEmailMessageCreationFailedPayload = z.object({
    additionalInfo: z.record(z.string(), z.any()).optional(),
    failureReason: z.nativeEnum(MAIL_FAILURE_REASONS),
});

export const schemaEmailMessageFailedPayload = z.object({
    error: z.string().min(1),
});

export const schemaEmailMessageSentPayload = z.object({
    info: z.object({
        accepted: z.array(z.string().email()).nullish(),
        envelope: z.object({
            from: z.string().email(),
            to: z.array(z.string().email()),
        }),
        messageId: z.string().min(1),
        pending: z.array(z.string().email()).nullish(),
        rejected: z.array(z.string().email()).nullish(),
        response: z.string().min(1),
    }),
});

export type Schema_EmailMessageCreatedPayload = z.infer<typeof schemaEmailMessageCreatedPayload>;
export type Schema_EmailMessageCreationFailedPayload = z.infer<typeof schemaEmailMessageCreationFailedPayload>;
export type Schema_EmailMessageFailedPayload = z.infer<typeof schemaEmailMessageFailedPayload>;
export type Schema_EmailMessageSentPayload = z.infer<typeof schemaEmailMessageSentPayload>;
